import React from "react";
import clsx from 'clsx'

export default function ProgressSteps(props) {
    const steps = props.steps
    const step = props.step
    const elems = []
    for(var i = 1; i <= steps; i++){
        elems.push(<span key={i} className={i <= step ? "active" : null}>
            {props.showNumbers ? i : null}
            {step >= steps && i >= steps && props.isValid ? <i className={"ui-icon ui-icon-check ui-icon_color-light"}/> : null}
        </span>)
    }
    return <div className={clsx("progress-steps", props.className)}>
        {elems}
    </div>
}